import { useState, useEffect } from 'react';
import { Modal } from '../ui/Modal';
import { getLegalDocument } from '../../api/legal';

export function LegalDocViewer({ open, onClose, slug, title }) {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !slug) return;
    setLoading(true);
    getLegalDocument(slug)
      .then(d => setDoc(d.document))
      .catch(() => setDoc(null))
      .finally(() => setLoading(false));
  }, [open, slug]);

  return (
    <Modal open={open} onClose={onClose} title={title || doc?.title || 'Sözleşme'} size="xl">
      {loading && (
        <div className="text-center py-8 text-slate-500">Yükleniyor...</div>
      )}
      {!loading && doc && (
        <div>
          <p className="text-xs text-slate-500 mb-4">
            Versiyon: {doc.version}
            {doc.effective_date || doc.published_at ? (
              <> · Yürürlük: {new Date(doc.effective_date || doc.published_at).toLocaleDateString('tr-TR')}</>
            ) : null}
          </p>
          <div
            className="prose prose-sm max-w-none text-slate-700"
            dangerouslySetInnerHTML={{ __html: doc.content_html }}
          />
        </div>
      )}
      {!loading && !doc && (
        <p className="text-slate-500 text-sm">Sözleşme yüklenemedi.</p>
      )}
    </Modal>
  );
}
